module.exports = __webpack_public_path__ + "img/toilet_family.22578537.png";